import { Injectable } from "@angular/core";
import { NetworkService } from "../shared/network.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private networkService: NetworkService) { }

  validateLogin(req: any) {
    return this.networkService.login("api/admins/login", req, null, null);
  }
  validateDispatcherLogin(req: any) {
    return this.networkService.login("api/dispatcher/login", req, null, null);
  }
  validateVendorLogin(req: any) {
    return this.networkService.login("api/vendor/login", req, null, null);
  }
  resetPassword(req: any) {
    return this.networkService.login(
      "api/admin/forgotPassword",
      req,
      null,
      null
    );
  }
  logout(): Observable<any> {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found, cannot log out.");
      return new Observable((observer) => {
        observer.error({ message: "No token provided" });
      });
    }
    const headers = {
      Authorization: `${token}`,
    };
    return this.networkService.post("api/admins/logout", {}, { headers });
  }

}
